import { trusted } from './html.js';

const STAR = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3 6.1 20.6l1.3-6.6L2.5 9.4l6.6-.8z';

// Stars as inline SVG: lamp-yellow fill for earned, 1.5 px lamp-yellow stroke for the rest. No number beside them.
export function stars(n) {
  const k = Math.max(0, Math.min(5, Math.round(Number(n) || 0)));
  const paths = [0, 1, 2, 3, 4].map(i =>
    `<path transform="translate(${i * 24} 0)" d="${STAR}" fill="${i < k ? '#F5C95C' : 'none'}" stroke="#F5C95C" stroke-width="1.5" vector-effect="non-scaling-stroke"/>`).join('');
  return trusted(`<svg class="stars" role="img" aria-label="${k} of 5 stars" viewBox="0 0 120 24" width="100" height="20">${paths}</svg>`);
}

export function starInput(name, value = 0) {
  const radios = [1, 2, 3, 4, 5].map(n =>
    `<input type="radio" name="${name}" value="${n}" aria-label="${n} of 5 stars"${n === value ? ' checked' : ''}>`).join('');
  return trusted(`<fieldset class="star-input"><legend>Your rating</legend><div>${radios}</div></fieldset>`);
}
